import { Result } from '@cplug/frontend-core/utils'
import { BaseGatewayErrorDTO, type DataWrappedDTO } from '@cplug/frontend-core/gateways'
import { isSuccessResponse, ErrorCodes, type BaseError } from '@cplug/frontend-core/models'
import type { OpeningHour } from '../models/OpeningHour'
import { mapDTOToOpeningHour, mapOpeningHourToDTO, OpeningHourDTO } from './DTOs/OpeningHourDTO'
import { CPBaseCRUDGateway } from '~/shared/gateways/CPBaseCRUDGateway'

type ListDTO = { opening_hours: OpeningHourDTO[] }

export class CPOpeningHoursGateway extends CPBaseCRUDGateway<OpeningHourDTO, ListDTO, OpeningHour> {
  protected override apiUrlDomain = 'opening-hours'

  protected override dtoToModelMapper = mapDTOToOpeningHour
  protected override modelToDtoMapper = mapOpeningHourToDTO
  protected override dtoSchema = OpeningHourDTO

  protected get listField (): keyof ListDTO {
    return 'opening_hours' as keyof ListDTO
  }

  protected override get modelIdField (): keyof OpeningHour {
    return 'id' as keyof OpeningHour
  }

  async save (
    models: OpeningHour[],
    sourceType?: string,
    fulfillmentType?: string
  ): Promise<Result<boolean>> {
    const data = models.map(this.modelToDtoMapper)
    const payload: Record<string, unknown> = { opening_hours: data }

    if (sourceType) { payload.source_type = sourceType }
    if (fulfillmentType) { payload.fulfillment_type = fulfillmentType }

    const response = await this.put<DataWrappedDTO<OpeningHourDTO>>(this.apiUrlDomain, payload)

    if (response == null || !isSuccessResponse(response)) {
      return Result.ofError(new BaseGatewayErrorDTO().deserialize(response?.data) ?? <BaseError>{ code: ErrorCodes.Unknown })
    }

    return Result.ofValue(true)
  }
}
